"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _mercurio = _interopRequireDefault(require("./mercurio"));
var _env = _interopRequireDefault(require("../../helpers/env"));
var _isSsr = require("../../helpers/isSsr");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var composeEnhancers = _env["default"].NODE_ENV !== 'production' && (0, _isSsr.isCsr)() ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose : _redux.compose;
var getMiddlewares = function getMiddlewares(props, options) {
  return composeEnhancers((0, _redux.applyMiddleware)((0, _mercurio["default"])(props, options)));
};
var _default = exports["default"] = getMiddlewares;